/**
 * 接口域名的管理
 */
const kaixue = {
    // 开发环境接口/测试接口
    dev: 'http://139.196.146.86/nationalday/',
    // dev:'http://106.15.170.130/nationalday/',
    //生产环境接口
    pro:'http://106.15.170.130/nationalday/'
}
let base = null;
if (process.env.NODE_ENV == 'development') {
    base = kaixue.dev
}
else if (process.env.NODE_ENV == 'production') {
    base = kaixue.pro
}
export default base;
